import React, { Component } from "react";
import { connect } from "react-redux";

import Label from "../../components/label";
import PatientQueueList from "../../containers/PatientQueueList";
import MakeAPICall from "../../apiCalls/common";
import RefreshButton from "../../components/refreshButton";
import CustomModal from "../../components/modal";

import appRoutes from "../../routes/appRoutes";

import {
  getBookingDetails,
  acceptConsultRequest,
  changeDoctorBusyState
} from "../../apiRoutes";

import { doctorAppointmentData } from "../../reduxStore/actions/commonAction";

class PatientsQueuePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiCall: null,
      refreshList: false,
      selectedAppointment: null,
      noLongerPopup: false,
      acceptRequestPopup: false,
      acceptRequestPopupText: "",
      bookingData: null,
      canTakeMedicareConsult: props.auth && props.auth.userData && props.auth.userData.canTakeMedicareConsult ? true : false,
      noMedicareAccessForConsult: false
    };
  }

  componentDidMount() {
    this.askForLeavePage();
    window.scrollTo(0, 0);

    // ERX Requirement
    // console.log("Component Mounted: ", this.props.auth.userData);
    // console.log("------------------------------");
    // console.log(this.props.auth.userData.passwordRefreshInterval);

    // if (this.props.auth.userData && !this.props.auth.userData.passwordRefreshInterval) {
    //   this.props.history.push(appRoutes.changePassword);
    // } else if (this.props.auth.userData && this.props.auth.userData.passwordRefreshInterval) {
    //   const isValidPasswordInterval = isAfterToday(this.props.auth.userData.passwordRefreshInterval);
    //   console.log("isValidPasswordInterval: ", isValidPasswordInterval);
    //   if (!isValidPasswordInterval) {
    //     this.props.history.push(appRoutes.changePassword);
    //   }
    // }
  }

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  askForLeavePage = () => {
    window.onbeforeunload = e => {
      e = e || window.event;

      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = "Sure?";
      }

      // For Safari
      return "Sure?";
    };
  };

  // accept the consult request
  acceptAppointment = data => {
    // only proceed if this doctor is first in queue
    console.log("CommonReducers: ", this.props.commonReducers);
    if (
      this.props.commonReducers &&
      this.props.commonReducers.doctorOnlineData !== undefined &&
      this.props.commonReducers.doctorOnlineData !== null &&
      this.props.commonReducers.doctorOnlineData.numberinQueue === "1st"
    ) {

      if (!this.state.canTakeMedicareConsult && data.isBulkBilled === true) {
        console.log("You do not have access to medicare consults");
        this.setState({
          noMedicareAccessForConsult: true
        });
      } else {
        this.setState({
          selectedAppointment: data,
          acceptRequestPopup: true,
          acceptRequestPopupText:
            "Do you accept " + data.patientName + "'s consult request?"
        });
      }

    }
  };

  refreshPatientsList = () => {
    this.setState({
      refreshList: true
    });

    setTimeout(() => {
      this.setState({
        refreshList: false
      });
    }, 1000);
  };

  closeAcceptRequestPopup = () => {
    this.setState({
      acceptRequestPopup: false,
      acceptRequestPopupText: ""
    });
  };

  acceptRequestConfirmed = () => {
    this.setState({
      acceptRequestPopup: false,
      acceptRequestPopupText: ""
    });

    setTimeout(() => {
      this.checkIfAppointmentStillValid(this.acceptConsultRequestStep);
    }, 1000);
  };

  closeNoLongerPopup = () => {
    this.setState({
      noLongerPopup: false
    });
  };

  // change doctor busy state with callback
  changeDoctorBusyStatusWithCallBack = (changeState, callback) => {
    let bodyDataDoctorState = new FormData();
    bodyDataDoctorState.append("isBusy", changeState);
    let apiCallParamDoctorState = {
      reqType: "PUT",
      reqURL: changeDoctorBusyState,
      dataObj: bodyDataDoctorState,
      params: {},
      headers: {},
      successCallback: async res => {
        callback();
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again : ", err);
        callback();
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParamDoctorState
    });
  };

  // check if appointment is cancelled by patient or not
  checkIfAppointmentStillValid = callback => {
    console.log("Checking appoint is valid or not: ", this.state.selectedAppointment);
    let apiCallParam = {
      reqType: "GET",
      reqURL: getBookingDetails,
      params: {
        booking_id: this.state.selectedAppointment._id
      },
      headers: {},
      successCallback: async res => {
        // patient have cancelled the consult request or it is already taken
        if (res.data.data.status > 1) {
          this.setState({
            noLongerPopup: true,
            bookingData: null
          });

          this.refreshPatientsList();

          setTimeout(() => {
            this.setState({
              noLongerPopup: false
            });
          }, 2000);
        } else {
          this.setState({
            bookingData: res
          });
          // proceed if everything is alright
          callback(res);
        }
      },
      failureCallback: err => {
        console.log(err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  acceptConsultRequestStep = (bookingData) => {
    let dt = {
      data: {
        data: {
          appointmentId: this.state.selectedAppointment._id,
          patientId: this.state.selectedAppointment.patientID
        }
      }
    };
    this.props.doctorAppointmentData(dt);

    let bodyData = new FormData();
    bodyData.append("doctorId", this.props.auth.userData._id);
    bodyData.append("patientId", this.state.selectedAppointment.patientID);
    bodyData.append(
      "appointmentId",
      this.state.selectedAppointment._id
    );
    let apiCallParam = {
      reqType: "PUT",
      reqURL: acceptConsultRequest,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: async res => {
        this.props.history.push(appRoutes.callRequestAccepted, {
          callRequestData: dt,
          bookingDataFromQueuePage: bookingData && bookingData.data && bookingData.data.data ? JSON.stringify(bookingData) : null
        });
        // this.changeDoctorBusyStatusWithCallBack(true, () => {
        // });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.changeDoctorBusyStatusWithCallBack(false, () => {
          this.props.history.push(appRoutes.dashboard);
        });
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  closeMedicareAccessPopUp = () => {
    this.setState({
      noMedicareAccessForConsult: false
    });
  }

  render() {
    return (
      <div className="row rounded p-3 ticket-page">
        {/* Top Filters */}
        <div className="col-sm-12 p-3">
          <Label title="Patients in Queue" className="big" />
          <RefreshButton onClick={this.refreshPatientsList} />
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-5">
          <PatientQueueList
            makeAPICall={this.componentAPICall}
            acceptAppointment={this.acceptAppointment}
            refreshList={this.state.refreshList}
            canTakeMedicareConsult={this.state.canTakeMedicareConsult}
          />
        </div>
        <CustomModal
          openModal={this.state.acceptRequestPopup}
          modalBodyContent={this.state.acceptRequestPopupText}
          okayText="Confirm"
          cancelText="Cancel"
          title="Instant Consult"
          useOneButton={false}
          okayEvent={this.acceptRequestConfirmed}
          cancelEvent={this.closeAcceptRequestPopup}
        />
        <CustomModal
          openModal={this.state.noMedicareAccessForConsult}
          modalBodyContent={`<p class="mb-0">You are not eligible to select this consult request as it is bulk-billed.</p> <p class="mb-0">Please select the next consult request in the queue.</p> <p>Contact Instant Consult Support if you require any assistance.</p>`}
          // okayText="Confirm"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          // okayEvent={this.acceptRequestConfirmed}
          cancelEvent={this.closeMedicareAccessPopUp}
        />
        <CustomModal
          openModal={this.state.noLongerPopup}
          modalBodyContent="Consult no longer available"
          title="Instant Consult"
          noButtons={true}
          cancelEvent={this.closeNoLongerPopup}
        />
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

// // get the store
const mapStateToProps = props => ({
  auth: props.auth.user,
  commonReducers: props.commonReducers
});

const mapDispatchToProps = dispatch => ({
  doctorAppointmentData: data => dispatch(doctorAppointmentData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsQueuePage);
